import { createRoot } from "react-dom/client";
import { useEffect } from "react";
import App from "./App.tsx";
import "./index.css";
import { initSentryClient } from "@/lib/sentryClient";
import { initAnalytics } from "@/lib/analytics";
import { assertClientEnv } from "@/lib/envClient";
import { AppErrorBoundary } from "@/components/AppErrorBoundary";

assertClientEnv();
initSentryClient();
initAnalytics();

function Root() {
  useEffect(() => { window.__appRecovery?.ready(); }, []);
  return <AppErrorBoundary><App /></AppErrorBoundary>;
}

createRoot(document.getElementById("root")!).render(<Root />);
